import styled from 'styled-components';
import MenuItem from '@mui/material/MenuItem';

import { StyledAutocomplete as BaseAutocomplete } from 'components/Input/styles';

import { TextInput } from 'ui/TextInput';

export const FilterItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const ColumnsContainer = styled.div`
  display: flex;
  align-items: center;

  width: 200px;
`;

export const OperatorContainer = styled(ColumnsContainer)`
  width: 120px;
`;

export const InputContainer = styled(ColumnsContainer)`
  min-width: 400px;
  width: fit-content;

  .MuiInputBase-root {
    font-size: 14px;
    height: 40px;
    border: none;
  }

  .MuiInputBase-input {
    font-size: 14px;
  }

  .MuiAutocomplete-input {
    padding: 0 14px !important;
  }

  .MuiPickersSectionList-root {
    width: auto;
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  font-size: 14px;
  max-width: 256px;
  white-space: break-spaces;
`;

export const DisabledTextInput = styled(TextInput)`
  background-color: ${({ theme }) => theme.palette.grey[100]};
  width: 100%;
`;

export const EntityContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const EntityName = styled.p`
  margin: 0;
  height: 14px;
  font-size: 12px;
  margin-bottom: 5px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const StyledColumnAutocomplete = styled(BaseAutocomplete)`
  .MuiAutocomplete-inputRoot {
    padding: 0;
    font-size: 14px;
    height: 40px;
  }

  .MuiAutocomplete-input {
    padding: 0 14px !important;
    font-size: 14px;
  }
` as typeof BaseAutocomplete;
